import script from "./OtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpInput.vue?vue&type=script&setup=true&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=ec4fb61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec4fb61a"]])

export default __exports__